import { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { EmployeeTimeOff } from '../../../types/EmployeeTimeOff';
import CustomAxios from '../../../utility/customAxios';
import { mutationKeys } from '../mutationKeys';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const updateEmployeeTimeOff = async (uuid: string, formData: EmployeeTimeOff) => {
  const response = await CustomAxios.put(`employee_time_offs/${uuid}`, formData);
  return response.data;
};

interface UseUpdateEmployeeTimeOffProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useUpdateEmployeeTimeOff({ uuid, onSuccessCallback }: UseUpdateEmployeeTimeOffProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateEmployeeTimeOff],
    mutationFn: (formData: EmployeeTimeOff) => updateEmployeeTimeOff(uuid, formData),
    onSuccess: (data: EmployeeTimeOff) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allEmployeeTimeOffs, data.uuid],
      });
      queryClient.invalidateQueries({
        queryKey: [queryKeys.employeeTimeOffAvailability],
      });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const employeeTimeOff = err.response.data as EmployeeTimeOff;
        queryClient.setQueryData([queryKeys.allEmployeeTimeOffs, employeeTimeOff.uuid], employeeTimeOff);
      }
    },
  });
}
